/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

import { jsx } from '@atlaskit/css';
// Uses @compiled/react because lineHeight and space-token width/height are not allowed by the strict @atlaskit/css types.
import { cssMap } from '@compiled/react';
import { token } from '@atlaskit/tokens';

const styledClearButtonStyles = cssMap({
	clearButton: {
		backgroundColor: 'transparent',
		borderWidth: 0,
		borderStyle: 'none',
		borderRadius: token('radius.xsmall'),
		color: token('color.text.subtlest'),
		cursor: 'pointer',
		height: token('space.300'),
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography -- preserving the original non-token lineHeight during the styled-components migration
		lineHeight: 1,
		outlineWidth: 0,
		paddingTop: 0,
		paddingRight: 0,
		paddingBottom: 0,
		paddingLeft: 0,
		display: 'flex',
		alignItems: 'center',
		marginLeft: token('space.025'),
		transitionProperty: 'background-color, opacity',
		transitionDuration: '200ms',
		width: token('space.300'),
		'&:hover': {
			color: token('color.text.subtle'),
		},
		'&:focus': {
			color: token('color.text.subtle'),
		},
	},
});

export const StyledClearButton = ({
	children,
	...props
}: React.ComponentPropsWithoutRef<'div'>): React.JSX.Element => (
	<div css={styledClearButtonStyles.clearButton} {...props}>
		{children}
	</div>
);
